import { render, staticRenderFns } from "./Zjgw.vue?vue&type=template&id=40812614&scoped=true&"
import script from "./Zjgw.vue?vue&type=script&lang=js&"
export * from "./Zjgw.vue?vue&type=script&lang=js&"
import style0 from "./Zjgw.vue?vue&type=style&index=0&id=40812614&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40812614",
  null
  
)

export default component.exports